import React from 'react';
import { Button, FooterActionBar } from '@saviynt/design-system';
import PropTypes from 'prop-types';

function CertsReassignFooter({
  isActionLoading,
  setIsReassignModalOpen,
  isBtnEnabled,
  handleSubmit,
  cancelText,
  submitText,
}) {
  return (
    <FooterActionBar className='CertsReassignModal-footer' size='large'>
      <div className='CertsReassignModal-actionButtons'>
        <Button
          type='button'
          kind='ghost'
          size='medium'
          isDisabled={isActionLoading}
          onClick={() => {
            setIsReassignModalOpen(false);
          }}>
          {cancelText}
        </Button>
        <Button
          className='CertsReassignModal-submitButton'
          type='button'
          kind={isBtnEnabled() ? 'filled' : 'outlined'}
          size='medium'
          onClick={handleSubmit}
          isLoading={isActionLoading}
          loaderText='Submit'>
          {submitText}
        </Button>
      </div>
    </FooterActionBar>
  );
}

CertsReassignFooter.propTypes = {
  isActionLoading: PropTypes.bool.isRequired,
  setIsReassignModalOpen: PropTypes.func.isRequired,
  isBtnEnabled: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  cancelText: PropTypes.string.isRequired,
  submitText: PropTypes.string.isRequired,
};

export default CertsReassignFooter;
